'use strict';
/* eslint-disable comma-dangle*/

export default {
  PayoutsGetRequest: require('./payoutsGetRequest').PayoutsGetRequest,
  PayoutsItemCancelRequest: require('./payoutsItemCancelRequest').PayoutsItemCancelRequest,
  PayoutsItemGetRequest: require('./payoutsItemGetRequest').PayoutsItemGetRequest,
  PayoutsPostRequest: require('./payoutsPostRequest').PayoutsPostRequest,
};
